import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import SliderReviews from '../../components/SliderReviews/SliderReviews';
import SMI from '../../components/SMI/SMI';
import Content from '../../components/Content/Content';
import './PageReviews.scss';
import './PageReviews-media.scss';
import DescriptionBlock from '../../components/DescriptionBlock/DescriptionBlock';
import SliderLogos from '../../components/SliderLogos/SliderLogos';
import FormContainer from '../../components/FormContainer/FormContainer';
import Input from '../../components/Input/Input';
import InputPhone from '../../components/Input/InputPhone';
import Textarea from '../../components/Textarea/Textarea';
import { ValidationFormItems } from '../../services/GlobalFunctions';
import { ServiceData } from '../../redux/services/ServiceRedux';
import Title from '../../components/Title/Title';
import CardHoverPoint from '../../components/CardHoverPoint/CardHoverPoint';
import { Props } from './interfaces';
import LogosPartners from '../../components/LogosPartners/LogosPartners';
import {content} from "../../services/content";
import {ICardHoverProps} from "../../components/DeliveryTypes/interfaces";
import {SMIList} from "../../components/SMI/Constants";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const PageReviews = ({
  reviews,
  blockedSend,
  blockedSendLoaded,
  recaptchaV2ref,
  pageContent,
  contactForms
}: Props) => {
  const [nameForm, setNameForm] = useState('');
  const [errorNameForm, setErrorNameForm] = useState<string | null>(null);
  const [phoneForm, setPhoneForm] = useState('+7');
  const [errorPhoneForm, setErrorPhoneForm] = useState<string | null>(null);
  const [msgForm, setMsgForm] = useState('');
  const [errorMsgForm, setErrorMsgForm] = useState<string | null>(null);
  const [serverText, setServerText] = useState('');
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const success = () => {
    setNameForm('');
    setPhoneForm('+7');
    setMsgForm('');
    setSuccessShow(true);
    setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
  };

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    if (!executeRecaptcha) {
      setDisableBtn(false);
      return;
    }

    const token = await executeRecaptcha(); // v3
    // const token = await recaptchaV2ref.current.executeAsync();

    if (
      !ValidationFormItems({
        fields: [msgForm],
        arrSetError: [setErrorMsgForm],
        phone: phoneForm,
        setErrorPhone: setErrorPhoneForm,
      })
    ) {
      setDisableBtn(false);
      return;
    }
    ServiceData.sendEmailContacts({
      data: {
        name: nameForm,
        phone: phoneForm,
        msg: msgForm,
        department: 0,
        orderNumber: '-',
      },
      token,
      success,
      setServerText,
      blockedSendLoaded,
      eventMetrika: 'form_feedback',
      contactFormId: contactForms.main_contact_form_id
    });
  };

  return (
    <div className="page-reviews">

      {pageContent.simple_header?.visible && <Content
        noLazy
        padding={{ paddingMain: { top: 0, bottom: 20 }, paddingMob: { top: 0, bottom: 0 } }}
        block={
          <Title
            h1
            gradient
            center
            title={pageContent.simple_header.title}
            text={pageContent.simple_header.description}
          />
        }
      />}

      <Content
        padding={{ paddingMain: { top: 0, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={<SMI list={SMIList} />}
      />

      {reviews.length ? (
        <Content
          padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
          block={<SliderReviews title={content.sliderContent.reviews.title} slides={reviews} />}
        />
      ) : null}

      {pageContent.reviews_benefits?.visible && <Content
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={
          <>
            <Title
              center
              marginBottom={40}
              title={pageContent.reviews_benefits.title}
            />
            <div className="page-reviews__grid-4 page-reviews__cards-point">
              {(pageContent.reviews_benefits.items || []).map((item: ICardHoverProps, i: number) => (
                <CardHoverPoint {...item} key={i} />
              ))}
            </div>

            {pageContent.reviews_benefits.text_block?.title
              && pageContent.reviews_benefits.text_block?.description
              && <DescriptionBlock
              title={pageContent.reviews_benefits.text_block.title}
              text={pageContent.reviews_benefits.text_block.description}
            />}
          </>
        }
      />}

      {pageContent.partners?.visible && <Content
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={
          <>
            <Title center title={pageContent.partners.title} marginBottom={40} />
            <LogosPartners list={pageContent.partners.items} />
          </>
        }
      />}

      <Content
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={
          <>
            <Title center marginBottom={40} title="Наши клиенты" />
            <SliderLogos padding="0" />
          </>
        }
      />

      <Content
        padding={{ paddingMain: { top: 80, bottom: 0 }, paddingMob: { top: 40, bottom: 0 } }}
        block={
          <FormContainer
            title="Оставьте отзыв о работе наших услуг курьерской доставки"
            subTitle="помогите стать еще лучше для ваших покупателей"
            buttonWidthAll
            disableBtn={disableBtn}
            showBlockedError={showBlockedError}
            form={
              <>
                <div className="page-reviews__form-grid">
                  <Input
                    label="Имя"
                    name="name"
                    value={nameForm}
                    onChange={(e: any) => setNameForm(e.target.value)}
                    error={errorNameForm}
                    marginTop={0}
                  />
                  <InputPhone
                    label="Телефон*"
                    name="phone"
                    value={phoneForm}
                    onChange={(e: any) => setPhoneForm(e.target.value)}
                    error={errorPhoneForm}
                    marginTop={0}
                  />
                </div>
                <Textarea
                  label="Сообщение*"
                  value={msgForm}
                  onChange={(e: any) => setMsgForm(e.target.value)}
                  error={errorMsgForm}
                />
              </>
            }
            onSubmit={handleReCaptchaVerify}
            serverText={serverText}
            successShow={successShow}
            heightSuccessForm="564px"
          />
        }
      />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageReviews));
